export async function httpGet(url, sforceSessionInfo, uniqueID) {
  return await fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      Accept: 'application/json',
      'Content-Security-Policy': "script-src 'self'",
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'Content-Type': 'application/json',
      sforceSessionInfo: sforceSessionInfo,
      uniqueID: uniqueID,
      statusMailId: uniqueID
    },
    referrerPolicy: 'no-referrer'
  }).then(function (response) {
    const jsonResponse = response.json();
    const returnedResponse = jsonResponse.then(resp => {
      const promise = new Promise((resolve, reject) => {
        if (response.status !== 200) {
          reject(resp);
        }
        resolve(resp);
      });
      return promise;
    });
    return returnedResponse;
  });
}
export async function httpGetMigrateStatus(url, jobId) {
  return await fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      'Content-Security-Policy': "script-src 'self'",
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      jobId: jobId
    },
    referrerPolicy: 'no-referrer'
  }).then(function (response) {
    const jsonResponse = response.json();
    const returnedResponse = jsonResponse.then(resp => {
      const promise = new Promise((resolve, reject) => {
        if (response.status !== 200) {
          reject(resp);
        }
        resolve(resp);
      });
      return promise;
    });
    return returnedResponse;
  });
}
export async function httpPost(url, sforceSessionInfo, tarforceSessionInfo, selectedData) {
  return await fetch(url, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Content-Security-Policy': "script-src 'self'",
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      sourceSessionInfo: sforceSessionInfo,
      targetSessionInfo: tarforceSessionInfo
    },
    body: selectedData,
    referrerPolicy: 'no-referrer'
  }).then(function (response) {
    if (response.status === 403) {
      const promise = new Promise((resolve, reject) => {
        if (response.status === 403) {
          reject(response);
        }
        resolve(response);
      });
      return promise;
    }
    const jsonResponse = response.json();
    const returnedResponse = jsonResponse.then(resp => {
      const promise = new Promise((resolve, reject) => {
        if (response.status !== 200) {
          reject(resp);
        }
        resolve(resp);
      });
      return promise;
    });
    return returnedResponse;
  });
}